import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { categories } from '../styles/variables';

// ── Category hero cover photos ──
import jacquardImg    from '../images/jacquard.png.jpeg';
import dobbyImg       from '../images/dobbyweave.png.jpeg';
import plainImg       from '../images/plainweave.png.jpeg';
import terryImg       from '../images/terry.png.jpeg';
import dishclothImg   from '../images/dishcloth.png.jpeg';
import printedImg     from '../images/printed..png.jpeg';
import kitchensetImg  from '../images/kitchenset.png.jpeg';
import othersImg      from '../images/others.png.jpeg';

// ── Jacquard product images ──
import jacquardClassicFloral    from '../images/jacquard/classic-floral-jacquard.jpg';
import jacquardGeometricDiamond from '../images/jacquard/geometric-diamond-weave.jpeg';
import jacquardHeritageStripe   from '../images/jacquard/heritage-stripe-jacquard.jpeg';
import jacquardBotanical        from '../images/jacquard/botanical-print-jacquard.jpeg';
import jacquardEdelweiss        from '../images/jacquard/edelweiss-jacquard.jpeg';
import jacquardGardenMotif      from '../images/jacquard/garden-motif-jacquard.jpeg';
import jacquardNautical         from '../images/jacquard/nautical-jacquard.jpeg';
import jacquardKitchenSet       from '../images/jacquard/jacquard-kitchen-set.jpeg';

// ── Dobby product images ──
import dobbyClassicCheck    from '../images/dobby/classic-check-dobby.jpeg';
import dobbyKitchenSet      from '../images/dobby/dobby-kitchen-set.jpeg';
import dobbyWaffleStripe    from '../images/dobby/waffle-stripe-dobby.jpeg';
import dobbySolidWaffle     from '../images/dobby/solid-waffle-dobby.jpeg';
import dobbyMultiStripe     from '../images/dobby/multi-stripe-dobby.jpeg';
import dobbyHerringbone     from '../images/dobby/herringbone-dobby.jpeg';
import dobbyBorderStripe    from '../images/dobby/border-stripe-dobby.jpeg';
import dobbyCheckeredSet    from '../images/dobby/checkered-dobby-set.jpeg';
import dobbyFineStripe      from '../images/dobby/fine-stripe-dobby.jpeg';
import dobbyMonoCheck       from '../images/dobby/gingham-check-dobby.jpeg';
import dobbyFrenchStripe    from '../images/dobby/french-stripe-dobby.jpeg';

// ── Plain Weave product images ──
import plainColorfulStripe  from '../images/plain/colorful-stripe-plain.jpeg';
import plainClassicBorder   from '../images/plain/classic-border-stripe.jpeg';
import plainBuffaloCheck    from '../images/plain/buffalo-check-plain.jpeg';
import plainRedGrid         from '../images/plain/red-grid-plain.jpeg';
import plainYellowPlaid     from '../images/plain/yellow-plaid-plain.jpeg';
import plainBlueGingham     from '../images/plain/blue-gingham-plain.jpeg';
import plainMultiStripe     from '../images/plain/multi-stripe-plain.jpeg';
import plainRainbowCheck    from '../images/plain/rainbow-check-plain.jpeg';
import plainWindowpane      from '../images/plain/windowpane-check-plain.jpeg';
import plainKitchenSet      from '../images/plain/plain-weave-kitchen-set.jpeg';
import plainNavyMixedSet    from '../images/plain/navy-mixed-plain-set.jpeg';

// ── Plain Weave — previously missing product images ──
import plainNaturalLinen    from '../images/plain/natural-linen-blend.jpeg';
import plainColouredStripe  from '../images/plain/coloured-stripe-plain.jpeg';
import plainStonewashed     from '../images/plain/stonewashed-plain.jpeg';

// ── Terry Kitchen product images ──
import terryBuffaloCheckSet    from '../images/terry/buffalo-check-terry-set.jpeg';
import terryMultiColorCheckSet from '../images/terry/multi-color-check-terry-set.jpeg';
import terryClassicCheck       from '../images/terry/classic-check-terry.jpeg';
import terryNeutralStripeSet   from '../images/terry/neutral-stripe-terry-set.jpeg';
import terryMultiStripe        from '../images/terry/multi-stripe-terry.jpeg';
import terryGreyStripeSet      from '../images/terry/grey-stripe-terry-set.jpeg';
import terryRainbowCheck       from '../images/terry/rainbow-check-terry.jpeg';
import terryWhiteBlueStripe    from '../images/terry/white-blue-stripe-terry.jpeg';
import terryGreyWovenStripe    from '../images/terry/grey-woven-stripe-terry.jpeg';
import terryWaffleCheckSet     from '../images/terry/waffle-check-terry-set.jpeg';

// ── Dish Cloth product images ──
import dishCheckSet        from '../images/dish/check-dish-cloth-set.jpeg';
import dishBeigeGrid       from '../images/dish/beige-grid-dish-cloth.jpeg';
import dishMulticolorCheck from '../images/dish/multicolor-check-dish-cloth.jpeg';
import dishMixedBulkSet    from '../images/dish/mixed-dish-cloth-bulk-set.jpeg';
import dishSolidGiftSet    from '../images/dish/solid-dish-cloth-gift-set.jpeg';

// ── Printed Kitchen product images ──
import printedApple           from '../images/printed/apple-print-printed.jpeg';
import printedBird            from '../images/printed/bird-print-printed.jpeg';
import printedCustomLogo      from '../images/printed/custom-logo-printed.jpeg';
import printedCustomText      from '../images/printed/custom-text-printed.jpeg';
import printedFloralBlock     from '../images/printed/floral-block-print.jpeg';
import printedFloralEmbroid   from '../images/printed/floral-embroidered-print.jpeg';
import printedFruitApplique   from '../images/printed/fruit-applique-printed.jpeg';
import printedGlassCloth      from '../images/printed/glass-cloth-printed.jpeg';
import printedKitchenNovelty  from '../images/printed/kitchen-novelty-printed.jpeg';
import printedKitchenSet      from '../images/printed/printed-kitchen-set.jpeg';

// ── Kitchen Sets product images ──
import ksBlueCheckApron       from '../images/kitchensets/blue-check-apron-kitchen-set.jpeg';
import ksGreyStripeApron      from '../images/kitchensets/grey-stripe-apron-kitchen-set.jpeg';
import ksRedTartanApron       from '../images/kitchensets/red-tartan-apron-kitchen-set.jpeg';
import ksNavyUtensilSet       from '../images/kitchensets/navy-utensil-print-kitchen-set.jpeg';
import ksOrangeStarSet        from '../images/kitchensets/orange-star-kitchen-set.jpeg';
import ksButterflyOvenGlove   from '../images/kitchensets/butterfly-print-double-oven-glove.jpeg';
import ksWhiteHalfApron       from '../images/kitchensets/white-half-apron.jpeg';
import ksWhiteBibApron        from '../images/kitchensets/white-bib-apron.jpeg';

// ── Others product images ──
import othersBabyDiaperBleached   from '../images/others/baby-diaper-bleached.jpeg';
import othersBabyDiaperGreige     from '../images/others/baby-diaper-greige.jpeg';
import othersBabyDiaperPrinted    from '../images/others/baby-diaper-printed.jpeg';
import othersBarMop               from '../images/others/bar-mop.jpeg';
import othersBarMopDyed           from '../images/others/bar-mop-dyed.jpeg';
import othersBathrobe             from '../images/others/bathrobe.png';
import othersCheesecloth          from '../images/others/cheesecloth.jpeg';
import othersFlameRetardant       from '../images/others/flame-retardant-fabric.png';
import othersFutaBeachTowel       from '../images/others/futa-beach-towel.jpeg';
import othersHandTowel            from '../images/others/hand-towel.jpg';
import othersShopTowels           from '../images/others/shop-towels.jpeg';
import othersTableCoverPlainDyed  from '../images/others/table-cover-plain-dyed.jpeg';
import othersTableCoverPrinted    from '../images/others/table-cover-printed.jpeg';
import othersTableCoverYarnDyed   from '../images/others/table-cover-yarn-dyed.jpeg';
import othersYarnDyedWovemGarments from '../images/others/yarndyedwovengarments.png';

// ── Cover image map ──
const coverImageMap = {
  'jacquard-weave':  jacquardImg,
  'dobby-weave':     dobbyImg,
  'plain-weave':     plainImg,
  'terry-kitchen':   terryImg,
  'dish-cloth':      dishclothImg,
  'printed-kitchen': printedImg,
  'kitchen-sets':    kitchensetImg,
  'others':          othersImg,
};

// ── Jacquard product image map ──
const jacquardProductImages = {
  'classic floral jacquard':    jacquardClassicFloral,
  'geometric diamond jacquard': jacquardGeometricDiamond,
  'heritage stripe jacquard':   jacquardHeritageStripe,
  'botanical leaf jacquard':    jacquardBotanical,
  'royal border jacquard':      jacquardEdelweiss,
  'wave pattern jacquard':      jacquardNautical,
  'garden motif jacquard':      jacquardGardenMotif,
  'garden vegetable jacquard':  jacquardGardenMotif, 
  'jacquard kitchen set':       jacquardKitchenSet,
  'jacquard mixed kitchen set': jacquardKitchenSet, 
};

// ── Dobby product image map ──
const dobbyProductImages = {
  'classic dobby check':              dobbyClassicCheck,
  'herringbone dobby':                dobbyHerringbone,
  'waffle dobby':                     dobbySolidWaffle,
  'stripe dobby':                     dobbyMultiStripe,
  'yarn dyed waffle dobby':           dobbyMultiStripe,
  'fine stripe dobby':                dobbyFineStripe,
  'french stripe dobby':              dobbyFrenchStripe,
  'mini chess dobby kitchen towel':   dobbyFrenchStripe,
  'border stripe dobby':              dobbyBorderStripe,
  'waffle stripe dobby':              dobbyWaffleStripe,
  'checkered dobby':                  dobbyCheckeredSet,
  'checkered dobby set':              dobbyCheckeredSet,
  'chess board dobby':                dobbyCheckeredSet,
  'dobby kitchen set':                dobbyKitchenSet,
  'kitchen set dobby':                dobbyKitchenSet,
  'mono check dobby':                 dobbyMonoCheck, // FIXED: Reassigned map exclusively to Mono Check Dobby
};

// ── Plain Weave product image map ──
const plainProductImages = {
  'natural linen blend': plainNaturalLinen,
  'coloured stripe':     plainColouredStripe,
  'stone washed':        plainStonewashed,
  'colorful stripe':     plainColorfulStripe,
  'yellow plaid':        plainYellowPlaid,
  'blue gingham':        plainBlueGingham,
  'multi stripe':        plainMultiStripe,
  'rainbow check':       plainRainbowCheck,
  'classic check':       plainWindowpane,
  'multi check':         plainKitchenSet,
  'navy mixed set':      plainNavyMixedSet,
  'stonewashed plain':   plainStonewashed,
  'plain weave set':     plainKitchenSet,
};

// ── Terry Kitchen product image map ──
const terryProductImages = {
  'buffalo check terry':              terryBuffaloCheckSet,
  'buffalo check terry set':          terryBuffaloCheckSet,
  'jacquard terry towel':             terryBuffaloCheckSet,
  'multi color check terry':          terryMultiColorCheckSet,
  'multi colour check terry':         terryMultiColorCheckSet,
  'classic check terry':              terryClassicCheck,
  'classic terry':                    terryClassicCheck,
  'neutral stripe terry':             terryNeutralStripeSet,
  'neutral terry set':                terryNeutralStripeSet,
  'multi stripe terry':               terryMultiStripe,
  'striped terry':                    terryMultiStripe,
  'grey stripe terry':                terryGreyStripeSet,
  'grey terry set':                   terryGreyStripeSet,
  'rainbow check terry':              terryRainbowCheck,
  'coloured check terry':             terryRainbowCheck,
  'white blue stripe terry':          terryWhiteBlueStripe,
  'blue stripe terry':                terryWhiteBlueStripe,
  'grey woven stripe terry':          terryGreyWovenStripe,
  'grey woven stripe reversed terry': terryGreyWovenStripe,
  'woven stripe terry':               terryGreyWovenStripe,
  'waffle check terry':               terryWaffleCheckSet,
  'waffle terry set':                 terryWaffleCheckSet,
  'terry kitchen set':                terryWaffleCheckSet,
};

// ── Dish Cloth product image map ──
const dishProductImages = {
  'check dish cloth':            dishCheckSet,
  'classic check dish cloth':    dishCheckSet,
  'dish cloth set':              dishCheckSet,
  'beige grid dish cloth':       dishBeigeGrid,
  'windowpane dish cloth':       dishBeigeGrid,
  'neutral dish cloth':          dishBeigeGrid,
  'multicolor check dish cloth': dishMulticolorCheck,
  'coloured check dish cloth':   dishMulticolorCheck,
  'mixed dish cloth bulk set':   dishMixedBulkSet,
  'bulk dish cloth set':         dishMixedBulkSet,
  'mixed dish cloth set':        dishMixedBulkSet,
  'solid dish cloth gift set':   dishSolidGiftSet,
  'solid dish cloth':            dishSolidGiftSet,
  'gift dish cloth set':         dishSolidGiftSet,
};

// ── Printed Kitchen product image map ──
const printedProductImages = {
  'apple print kitchen towel':    printedApple,
  'apple print printed':          printedApple,
  'bird print kitchen towel':     printedBird,
  'bird print printed':           printedBird,
  'custom logo printed':          printedCustomLogo,
  'custom logo kitchen towel':    printedCustomLogo,
  'custom text printed':          printedCustomText,
  'custom text kitchen towel':    printedCustomText,
  'floral block print':           printedFloralBlock,
  'floral block printed':         printedFloralBlock,
  'floral embroidered print':     printedFloralEmbroid,
  'floral embroidered printed':   printedFloralEmbroid,
  'fruit applique printed':       printedFruitApplique,
  'fruit applique kitchen towel': printedFruitApplique,
  'glass cloth printed':          printedGlassCloth,
  'glass cloth kitchen towel':    printedGlassCloth,
  'kitchen novelty printed':      printedKitchenNovelty,
  'novelty print kitchen towel':  printedKitchenNovelty,
  'printed kitchen set':          printedKitchenSet,
  'printed kitchen towel set':    printedKitchenSet,
};

// ── Kitchen Sets product image map ──
const kitchenSetsProductImages = {
  'blue check apron kitchen set':      ksBlueCheckApron,
  'blue check apron set':              ksBlueCheckApron,
  'grey stripe apron kitchen set':     ksGreyStripeApron,
  'grey stripe apron set':             ksGreyStripeApron,
  'red tartan apron kitchen set':      ksRedTartanApron,
  'red tartan apron set':              ksRedTartanApron,
  'navy utensil print kitchen set':    ksNavyUtensilSet,
  'navy utensil set':                  ksNavyUtensilSet,
  'orange star kitchen set':           ksOrangeStarSet,
  'star print kitchen set':            ksOrangeStarSet,
  'butterfly print double oven glove': ksButterflyOvenGlove,
  'butterfly oven glove':              ksButterflyOvenGlove,
  'white half apron':                  ksWhiteHalfApron,
  'waist apron':                       ksWhiteHalfApron,
  'white bib apron':                   ksWhiteBibApron,
  'plain white apron':                 ksWhiteBibApron,
};

// ── Others product image map ──
const othersProductImages = {
  'baby diaper bleached':        othersBabyDiaperBleached,
  'baby diaper greige':          othersBabyDiaperGreige,
  'baby diaper printed':         othersBabyDiaperPrinted,
  'bar mop':                     othersBarMop,
  'bar mop dyed':                othersBarMopDyed,
  'bathrobe':                    othersBathrobe,
  'cheesecloth':                 othersCheesecloth,
  'fr hvac duct wrapping fabric': othersFlameRetardant, 
  'futa beach towel':            othersFutaBeachTowel,
  'hand towel':                  othersHandTowel,
  'shop towels':                 othersShopTowels,
  'table cover plain dyed':      othersTableCoverPlainDyed,
  'table cover printed':         othersTableCoverPrinted,
  'table cover yarn dyed':       othersTableCoverYarnDyed,
  'yarn dyed wovem garments':   othersYarnDyedWovemGarments,
};

const getProductImage = (categoryId, productName) => {
  const key = productName.toLowerCase().trim();
  if (categoryId === 'jacquard-weave')  return jacquardProductImages[key] || null;
  if (categoryId === 'dobby-weave')     return dobbyProductImages[key] || null;
  if (categoryId === 'plain-weave')     return plainProductImages[key] || null;
  if (categoryId === 'terry-kitchen')   return terryProductImages[key] || null;
  if (categoryId === 'dish-cloth')      return dishProductImages[key] || null;
  if (categoryId === 'printed-kitchen') return printedProductImages[key] || null;
  if (categoryId === 'kitchen-sets')    return kitchenSetsProductImages[key] || null;
  if (categoryId === 'others')          return othersProductImages[key] || null;
  return null;
};

const jacquardExtraCards = [
  { name: 'Garden Vegetable Jacquard', desc: 'Colorful vegetable and garden motifs woven in vibrant jacquard.', img: jacquardGardenMotif },
];

const dobbyExtraCards = [
  { name: 'Yarn Dyed Waffle Dobby',          desc: 'Vibrant multicolor stripes on crisp white dobby base.',       img: dobbyMultiStripe  },
  { name: 'Fine Stripe Dobby',              desc: 'Delicate fine stripes for a subtle, elegant kitchen look.',    img: dobbyFineStripe   },
  { name: 'Mini Chess Dobby Kitchen Towel', desc: 'Classic French-style blue and white mini chess pattern.',      img: dobbyFrenchStripe },
  { name: 'Border Stripe Dobby',            desc: 'Bold border stripes with a premium herringbone body.',         img: dobbyBorderStripe },
  { name: 'Chess Board Dobby',              desc: 'Colorful checkered dobby towels, perfect as a gift set.',      img: dobbyCheckeredSet },
  { name: 'Mono Check Dobby',               desc: 'Traditional mono check in a range of fresh colors.',           img: dobbyMonoCheck    },
  { name: 'Waffle Stripe Dobby',            desc: 'Waffle weave with refined dobby stripe detailing.',             img: dobbyWaffleStripe },
  { name: 'Dobby Kitchen Set',              desc: 'Coordinated dobby kitchen set with mixed patterns.',            img: dobbyKitchenSet   },
];

const terryExtraCards = [
  { name: 'Jacquard Terry Towel',             desc: 'Classic black & white buffalo check terry towels stacked in a set.',         img: terryBuffaloCheckSet    },
  { name: 'Multi Colour Check Terry Set',     desc: 'Coordinated check terry set in brown, red and blue colourways.',             img: terryMultiColorCheckSet },
  { name: 'Classic Check Terry',              desc: 'Traditional red, green and blue check terry kitchen towels.',                 img: terryClassicCheck       },
  { name: 'Neutral Stripe Terry Set',         desc: 'Mixed neutral stripe and waffle terry set in beige and brown tones.',        img: terryNeutralStripeSet   },
  { name: 'Multi Stripe Terry',               desc: 'Vivid multicolour stripes on mustard, teal, orange and black terry base.',   img: terryMultiStripe        },
  { name: 'Grey Stripe Terry Set',            desc: 'Crisp 4-piece grey and white stripe terry kitchen towel set.',               img: terryGreyStripeSet      },
  { name: 'Rainbow Check Terry',              desc: 'Bold rainbow-coloured check pattern on a deep charcoal terry base.',         img: terryRainbowCheck       },
  { name: 'White Blue Stripe Terry',          desc: 'Classic white terry with clean navy blue centre stripes.',                   img: terryWhiteBlueStripe    },
  { name: 'Grey Woven Stripe Reversed Terry', desc: 'Premium grey woven stripe terry with plush loop reverse.',                   img: terryGreyWovenStripe    },
  { name: 'Waffle Check Terry Set',           desc: 'White waffle-weave terry set with teal, red and black check options.',       img: terryWaffleCheckSet     },
];

const dishExtraCards = [
  { name: 'Beige Grid Dish Cloth',       desc: 'Elegant beige and gold windowpane grid dish cloth, soft and absorbent.',     img: dishBeigeGrid       },
  { name: 'Multicolor Check Dish Cloth', desc: 'Bold red, blue and orange check dish cloths stacked in assorted colours.',   img: dishMulticolorCheck },
  { name: 'Mixed Dish Cloth Bulk Set',   desc: 'Large bulk set of mixed check and stripe dish cloths in vibrant colours.',   img: dishMixedBulkSet    },
  { name: 'Solid Dish Cloth Gift Set',   desc: 'Premium navy, green and grey solid dish cloths presented as a gift set.',    img: dishSolidGiftSet    },
];

const printedExtraCards = [
  { name: 'Apple Print Kitchen Towel',   desc: 'Cheerful apple motif screen-printed on soft cotton kitchen towels.',         img: printedApple          },
  { name: 'Bird Print Kitchen Towel',    desc: 'Decorative bird and branch print in a crisp, nature-inspired palette.',      img: printedBird           },
  { name: 'Floral Block Print',         desc: 'Hand-inspired floral block print in bold, export-quality ink.',              img: printedFloralBlock    },
  { name: 'Floral Embroidered Print',    desc: 'Delicate floral embroidery detailing on a fine woven cotton base.',          img: printedFloralEmbroid  },
  { name: 'Fruit Appliqué Printed',      desc: 'Vibrant fruit appliqué and print combination for a lively kitchen accent.',  img: printedFruitApplique  },
  { name: 'Glass Cloth Printed',        desc: 'Traditional glass cloth weave with a bold printed stripe or motif.',          img: printedGlassCloth     },
  { name: 'Kitchen Novelty Printed',    desc: 'Fun novelty kitchen-themed prints, popular for gifting and retail display.',  img: printedKitchenNovelty },
  { name: 'Custom Logo Printed',        desc: 'Premium blank canvas for custom brand logo printing — MOQ available.',        img: printedCustomLogo     },
  { name: 'Custom Text Printed',        desc: 'Personalised text printing on quality kitchen towels for branded orders.',    img: printedCustomText     },
  { name: 'Printed Kitchen Set',        desc: 'Coordinated printed kitchen towel set, styled and export-ready.',             img: printedKitchenSet     },
];

const kitchenSetsExtraCards = [
  { name: 'Blue Check Apron Kitchen Set',      desc: 'Navy blue check apron with matching oven mitts and pot holders — a complete coordinated set.',    img: ksBlueCheckApron     },
  { name: 'Grey Stripe Apron Kitchen Set',     desc: 'Classic grey and white ticking stripe apron, oven mitt and potholder in a neat gift set.',        img: ksGreyStripeApron    },
  { name: 'Red Tartan Apron Kitchen Set',      desc: 'Bold red tartan plaid apron, oven glove and pot holder — ideal for festive gifting.',             img: ksRedTartanApron     },
  { name: 'Navy Utensil Print Kitchen Set',    desc: 'Navy apron paired with utensil-motif oven mitt and potholder, styled for export retail.',         img: ksNavyUtensilSet     },
  { name: 'Orange Star Kitchen Set',           desc: 'Vibrant orange and green star-print full kitchen set: apron, double glove, mitt, towels & potholder.', img: ksOrangeStarSet  },
  { name: 'Butterfly Print Double Oven Glove', desc: 'Elegant sage green butterfly-print double oven glove with terry lining — premium export quality.', img: ksButterflyOvenGlove },
  { name: 'White Half Apron',                  desc: 'Clean white waist apron with a large front pocket — versatile for hospitality and catering.',      img: ksWhiteHalfApron     },
  { name: 'White Bib Apron',                   desc: 'Classic full-length white bib apron, soft cotton, ideal for branded or plain export orders.',      img: ksWhiteBibApron      },
];

const CategoryPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const cat = categories.find((c) => c.id === id);

  if (!cat) {
    return (
      <div style={{ paddingTop: '120px', textAlign: 'center', minHeight: '60vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
        <h2 style={{ fontFamily: 'var(--font-heading)', fontSize: '2rem', marginBottom: '1rem' }}>Category not found</h2>
        <button className="btn-primary" onClick={() => navigate('/')}>Go Home</button>
      </div>
    );
  }

  const coverImg = coverImageMap[cat.id];

  const handleInquire = () => {
    navigate('/');
    setTimeout(() => {
      const el = document.getElementById('contact');
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }, 400);
  };

  return (
    <div className="cat-page">
      {/* ── Category Hero — full cover photo ── */}
      <div style={{ position: 'relative', width: '100%', minHeight: '320px', display: 'flex', alignItems: 'flex-end', overflow: 'hidden' }}>
        <img
          src={coverImg}
          alt={cat.name}
          style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'center' }}
        />
        <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(to bottom, rgba(10,8,5,0.25) 0%, rgba(10,8,5,0.68) 100%)' }} />

        <div style={{ position: 'relative', zIndex: 2, width: '100%', padding: 'clamp(1rem, 3vw, 2rem) clamp(1rem, 3vw, 2rem)', paddingTop: '80px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '1.75rem' }}>
            <button
              onClick={() => {
                navigate('/');
                setTimeout(() => {
                  const el = document.getElementById('categories');
                  if (el) el.scrollIntoView({ behavior: 'smooth' });
                }, 400);
              }}
              style={{ fontFamily: "'Jost', sans-serif", fontSize: '0.78rem', fontWeight: 500, letterSpacing: '0.06em', color: 'rgba(255,255,255,0.75)', background: 'none', border: 'none', cursor: 'pointer', padding: 0, transition: 'color 0.2s' }}
              onMouseEnter={e => e.currentTarget.style.color = '#D4AF7A'}
              onMouseLeave={e => e.currentTarget.style.color = 'rgba(255,255,255,0.75)'}
            >← Back</button>
            <span style={{ color: 'rgba(255,255,255,0.35)', fontSize: '0.75rem' }}>/</span>
            <button
              onClick={() => {
                navigate('/');
                setTimeout(() => {
                  const el = document.getElementById('categories');
                  if (el) el.scrollIntoView({ behavior: 'smooth' });
                }, 400);
              }}
              style={{ fontFamily: "'Jost', sans-serif", fontSize: '0.78rem', fontWeight: 500, letterSpacing: '0.06em', color: 'rgba(255,255,255,0.55)', background: 'none', border: 'none', cursor: 'pointer', padding: 0, transition: 'color 0.2s' }}
              onMouseEnter={e => e.currentTarget.style.color = '#D4AF7A'}
              onMouseLeave={e => e.currentTarget.style.color = 'rgba(255,255,255,0.55)'}
            >Categories</button>
            <span style={{ color: 'rgba(255,255,255,0.35)', fontSize: '0.75rem' }}>/</span>
            <span style={{ fontFamily: "'Jost', sans-serif", fontSize: '0.78rem', color: '#D4AF7A' }}>{cat.shortName}</span>
          </div>

          <h1 style={{ fontFamily: "'Cormorant Garamond', Georgia, serif", fontSize: 'clamp(2.2rem, 5vw, 3.8rem)', fontWeight: 400, color: '#fff', lineHeight: 1.12, marginBottom: '1rem', letterSpacing: '-0.01em' }}>
            {cat.name}
          </h1>
          <div style={{ width: '52px', height: '2px', background: 'linear-gradient(90deg, #B8965A, transparent)', marginBottom: '1rem' }} />
          <p style={{ fontFamily: "'Jost', sans-serif", fontSize: 'clamp(0.9rem, 1.4vw, 1.05rem)', fontWeight: 300, color: 'rgba(255,255,255,0.8)', maxWidth: '560px', lineHeight: 1.75, letterSpacing: '0.02em' }}>
            {cat.description}
          </p>
        </div>
      </div>

      {/* ── Specs Bar ── */}
      <div className="cat-specs-bar">
        <div className="container">
          <div className="cat-specs-inner">
            {Object.entries(cat.specs).map(([key, value], i, arr) => (
              <React.Fragment key={key}>
                <div className="cat-spec-item">
                  <span className="cat-spec-label">{key}</span>
                  <span className="cat-spec-value">{value}</span>
                </div>
                {i < arr.length - 1 && <div className="cat-spec-dot" />}
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>

      {/* ── Products Grid ── */}
      <div className="cat-products">
        <div className="container">
          <div className="section-header" style={{ marginBottom: '1.5rem' }}>
            <div className="section-eyebrow">Our Range</div>
            <h2 className="section-title">{cat.id === 'plain-weave' ? 'Flat Weave Products' : `${cat.shortName} Products`}</h2>
            <div className="gold-divider"><div className="gold-divider-diamond" /></div>
          </div>

          <div className="cat-products-grid">
            {cat.products
              .filter(product => product.name.toLowerCase() !== 'gingham check dobby' && product.name.toLowerCase() !== 'gingham dobby') // FIXED: Automatically hides the duplicate items
              .filter((product) =>
                (cat.id === 'terry-kitchen' || cat.id === 'dish-cloth' || cat.id === 'plain-weave' || cat.id === 'printed-kitchen' || cat.id === 'kitchen-sets' || cat.id === 'others')
                  ? getProductImage(cat.id, product.name) !== null
                  : true
              )
              .map((product, i) => {
                const productImg = getProductImage(cat.id, product.name);
                return (
                  <ProductCard
                    key={`${cat.id}-${product.name}-${i}`}
                    product={product}
                    cat={cat}
                    productImg={productImg}
                    index={i}
                  />
                );
              })}
          </div>

          <div style={{ textAlign: 'center' }}>
            <button className="cat-inquire-btn" onClick={handleInquire}>
              ✉ Inquire About {cat.shortName}
            </button>
          </div>
        </div>
      </div>

      {/* ── Other Categories ── */}
      <div style={{ background: 'var(--color-beige)', padding: '2rem 0', borderTop: '1px solid var(--color-border)' }}>
        <div className="container">
          <div style={{ textAlign: 'center', marginBottom: '1.5rem' }}>
            <div className="section-eyebrow">Explore More</div>
            <h3 style={{ fontFamily: 'var(--font-heading)', fontSize: '1.6rem', fontWeight: 400 }}>Other Categories</h3>
          </div>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.75rem', justifyContent: 'center' }}>
            {categories
              .filter((c) => c.id !== cat.id)
              .map((other) => (
                <button
                  key={other.id}
                  onClick={() => navigate(`/category/${other.id}`)}
                  style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', fontFamily: 'var(--font-body)', fontSize: '0.82rem', fontWeight: 500, color: 'var(--color-dark-grey)', background: 'var(--color-warm-white)', border: '1px solid var(--color-border)', borderRadius: 'var(--radius-full)', padding: '0.5rem 1.25rem', cursor: 'pointer', transition: 'var(--trans-base)' }}
                  onMouseEnter={(e) => { e.currentTarget.style.borderColor = other.color; e.currentTarget.style.color = other.color; e.currentTarget.style.transform = 'translateY(-2px)'; }}
                  onMouseLeave={(e) => { e.currentTarget.style.borderColor = 'var(--color-border)'; e.currentTarget.style.color = 'var(--color-dark-grey)'; e.currentTarget.style.transform = 'translateY(0)'; }}
                >
                  {other.shortName}
                </button>
              ))}
          </div>
        </div>
      </div>
    </div>
  );
};

// ── Helper: generate a URL-safe slug from a product name ──
const toSlug = (name) =>
  name.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '');

// ── Product Card ──
const ProductCard = ({ product, cat, productImg, index }) => {
  const [hovered, setHovered] = React.useState(false);
  const navigate = useNavigate();

  const handleCardClick = () => {
    const slug = toSlug(product.name);
    navigate(`/product/${cat.id}/${slug}`, {
      state: { product, productImg, categoryId: cat.id },
    });
  };

  return (
    <div
      className={`product-card animate-fade-up delay-${(index % 6) + 1}`}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onClick={handleCardClick}
      style={{ overflow: 'hidden', cursor: 'pointer' }}
    >
      <div
        className="product-card-img"
        style={{
          position: 'relative',
          background: productImg ? 'transparent' : `linear-gradient(135deg, ${cat.bgColor}, ${cat.color}22)`,
          overflow: 'hidden',
          padding: 0,
        }}
      >
        {productImg ? (
          <>
            <img
              src={productImg}
              alt={product.name}
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                display: 'block',
                transform: hovered ? 'scale(1.06)' : 'scale(1)',
                transition: 'transform 0.45s ease',
              }}
            />
            <div style={{
              position: 'absolute',
              inset: 0,
              background: 'rgba(184,150,90,0.12)',
              opacity: hovered ? 1 : 0,
              transition: 'opacity 0.3s ease',
              pointerEvents: 'none',
            }} />
            <div style={{
              position: 'absolute',
              inset: 0,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              background: 'rgba(10,8,5,0.38)',
              opacity: hovered ? 1 : 0,
              transition: 'opacity 0.3s ease',
              pointerEvents: 'none',
            }}>
              <span style={{
                fontFamily: "'Jost', sans-serif",
                fontSize: '0.78rem',
                fontWeight: 600,
                letterSpacing: '0.12em',
                textTransform: 'uppercase',
                color: '#fff',
                background: 'rgba(184,150,90,0.9)',
                padding: '0.45rem 1.1rem',
                borderRadius: '2px',
              }}>
                View Details
              </span>
            </div>
          </>
        ) : (
          <>
            <div className="product-card-img-pattern" />
            <span role="img" aria-label={product.name} style={{ position: 'relative', zIndex: 1 }}>{cat.emoji}</span>
          </>
        )}
      </div>

      <div className="product-card-body">
        <div className="product-card-name">{product.name}</div>
        <p className="product-card-desc">{product.desc}</p>
      </div>
    </div>
  );
};

export default CategoryPage;